/* eslint-disable no-undef */
import React from 'react';
import { Provider } from 'react-redux';
import ReactOnRails from 'react-on-rails';
import PropTypes from 'prop-types';
import MainLayout from '../../containers/MainLayout/MainLayout';
import MainSearch from '../../containers/MainSearch/MainSearch';
import VirtualTourLeftPart from '../../containers/VirtualTourPage/VirtualTourLeftPart/VirtualTourLeftPart';
import VirtualTourRightPart from '../../containers/VirtualTourPage/VirtualTourRightPart/VirtualTourRightPart';
import './style.sass';

const VirtualTourPage = (props) => {
  const appStore = ReactOnRails.getStore('appStore');
  const { footerData } = props;

  return (
    <div>
      <Provider store={appStore}>
        <MainLayout footerData={footerData}>
          <div className="grey-background">
            <div className="container">
              <div className="row">
                <VirtualTourLeftPart />
                <VirtualTourRightPart />
              </div>
              <MainSearch />
            </div>
          </div>
        </MainLayout>
      </Provider>
    </div>
  );
};

VirtualTourPage.propTypes = {
  footerData: PropTypes.oneOfType([PropTypes.object]),
};

VirtualTourPage.defaultProps = {
  footerData: {},
};

export default VirtualTourPage;
